import { IAppConfig } from '../interfaces';

export const AppConfig: IAppConfig  = {
  AppName: "Divardy Web-App",
  AppVersion: "1.0.0",
  AppLogo: "divardy",

  ApiHost: "https://backend.divardy.nl",
  //ApiHost: "http://localhost",
  ApiUrl: "api/",

  ApiProtocol: "https://",
  //ApiProtocol: "http://",
  ApiMethod: "server",
  ApiPort: "",
  //ApiPort: ":4201",
  ApiLoginHost: "backend.divardy.nl",
  //ApiLoginHost: "localhost",
  ApiLoginUrl: "/api/auth/login",
  ApiApplicationId: 1,

  LogLevel: "Debug",
  Languages: ["nl", "en"],
  DefaultLanguage: "en",
  DefaultApplication: "",

  AvailableModules: [],
  DisabledModules: []
};